import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import SmoothScroll from "./components/SmoothScroll";
import Cursor from "./components/Cursor";
import ScrollProgress from "./components/ScrollProgress";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import BookingPage from "./pages/BookingPage";
import EventsPage from "./pages/EventsPage";
import GalleryPage from "./pages/GalleryPage";
import TestimonialsPage from "./pages/TestimonialsPage";
import ContactPage from "./pages/ContactPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { AdminProvider, useAdmin } from "./admin/AdminAuth";
import { MediaProvider } from "./context/MediaContext";
import { Toaster } from "./components/ui/toaster";

function ProtectedAdmin({ children }) {
  const { admin } = useAdmin();
  if (admin === undefined) {
    return <div className="min-h-screen grid place-items-center bg-[#0A3B2E] text-white/60">Loading…</div>;
  }
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}

function PublicSite() {
  return (
    <SmoothScroll>
      <Cursor />
      <ScrollProgress />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/booking" element={<BookingPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/testimonials" element={<TestimonialsPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
      <Footer />
    </SmoothScroll>
  );
}

function App() {
  return (
    <div className="App grain">
      <MediaProvider>
        <BrowserRouter>
          <AdminProvider>
            <Routes>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<ProtectedAdmin><AdminDashboard /></ProtectedAdmin>} />
              <Route path="/*" element={<PublicSite />} />
            </Routes>
            <Toaster />
          </AdminProvider>
        </BrowserRouter>
      </MediaProvider>
    </div>
  );
}

export default App;
